import type { ReactNativeFile } from 'apollo-upload-client';
import { Subscription } from 'zen-observable-ts';

import { AccountApi } from '@/api/account.api';
import { ChatApi } from '@/api/chat.api';
import { EventsApi } from '@/api/events.api';
import { GatewayApi } from '@/api/gateway.api';
import { NewMessageSubscription } from '@/generated/graphql';
import { ChatMessage } from './messages';

export const ChannelType = {
  CHANNEL: 'channel',
  NOTES: 'notes',
  SLEEP: 'sleep',
  FOOD: 'food',
  THOUGHT: 'thought',
  LESSON: 'lesson',
  GROUP: 'group',
} as const;

export type ChannelType = (typeof ChannelType)[keyof typeof ChannelType];

export interface ChannelUser {
  id: string;
  reference: string;
  userId: string;
  metadata?: MetadataInput[];
}

export interface Channel {
  id: string;
  name: string;
  type: ChannelType;
  lastMessageId?: string;
  status?: string;
  createdAt: Date;
  updatedAt: Date;
  unreadCount: number;
  chat?: Partial<ChatMessage>;
  users: ChannelUser[];
  metadata?: MetadataInput[];
}

export interface ChatChannelOptions {
  chatClient: ChatApi;
  gatewayClient: GatewayApi;
  accountClient: AccountApi;
  eventsClient?: EventsApi;
  roomId?: string;
  senderId?: string;
  lastKey?: string;
  lastKeys: Map<string, string[]>;
}

export interface GetMessagesParams {
  limit?: number;
  after?: string;
}

export interface GetMessagesResponse {
  roomId: string;
  count: number;
  lastKey?: string;
  chats: ChatMessage[] | [];
}

export interface SendTextMessageParams {
  message: string;
  replyTo?: string;
}

export interface SubscriptionObserver<T> {
  start?: (subscription: Subscription) => void;
  next: (value: T) => void;
  error?: (error: any) => void;
  complete?: () => void;
}

export interface NewMessageData {
  data: NewMessageSubscription;
}

export type SubscriptionCallback<TData = any> = ({
  data,
  error,
  connected,
}: {
  data?: TData;
  error?: Error;
  connected?: boolean;
}) => void;

export interface SendMediaMessageParams {
  file: ReactNativeFile | any;
  replyTo?: string;
}

export type MetadataInput = {
  key: string;
  value: string;
};

export type GetIndividualMessageParam = {
  id: string;
  roomId?: string;
};

export type NaluriLogout = {
  success: boolean;
};
